// metadata/operations.ts
import { A } from "@adornis/base/env-info.js";
import { handleClientRequest } from "../client/requestHandler.js";
import { upgradeMiddleware } from "../server/middlewares/upgradeArguments.js";
import { handleServerRequest } from "../server/requestHandler.js";
import { operationName as opNameSymbol } from "../symbols.js";
import { getOperationDict } from "./metaDataStore.js";
import { BQLReflect } from "./reflect.js";
import {
  getArrayDepth,
  unwrapType
} from "./types.js";
var assertValidEntity = (entity, operationName) => {
  if (entity && entity.constructor !== Function)
    throw new Error(
      `Queries only allowed as static functions (${operationName} on ${entity.constructor._class})`
    );
};
var assertNoExistingOperation = (operations, operationName, opType, entity) => {
  const existingOperation = operations[operationName];
  if (existingOperation) {
    throw new Error(
      `Trying to define duplicate ${opType} ${operationName}. ${entity ? `Dupicate ${opType} wants to be defined on entity ${entity._class}. ` : ""}${existingOperation.originalThis ? `Name is already taken by ${existingOperation.originalThis._class}.${operationName}.` : ""}`
    );
  }
};
function registerOperation({
  type,
  opType,
  entity = null,
  middlewares = [],
  operationName,
  resolve,
  options,
  params = []
}) {
  assertValidEntity(entity, operationName);
  const operations = getOperationDict(opType);
  assertNoExistingOperation(operations, operationName, opType, entity);
  const unwrappedType = unwrapType(type);
  const arrayDepth = getArrayDepth(type);
  const opParams = entity ? (
    // @Arg decorators are evaluated back to front, so we have to reverse here
    (BQLReflect.getMetadata(entity, operationName) ?? []).reverse()
  ) : params.map((param, index) => ({
    name: param.name,
    type: unwrapType(param.type),
    arrayDepth: getArrayDepth(param.type),
    parameterIndex: index
  }));
  const op = {
    name: operationName,
    type: unwrappedType,
    arrayDepth,
    options: { ...options, resolve },
    params: opParams,
    middlewares: A.isServer ? [upgradeMiddleware, ...middlewares] : [],
    originalThis: entity
  };
  operations[operationName] = op;
  const operationFunction = A.isClient ? handleClientRequest(opType, op) : handleServerRequest(opType, op);
  operationFunction[opNameSymbol] = operationName;
  return operationFunction;
}
export {
  registerOperation
};
